export const ACTIONS = ['fire', 'primary', 'secondary', 'field'] as const;
export type Action = typeof ACTIONS[number];
export type Bindings = [Record<Action, string>, Record<Action, string>];
export const DEFAULT_BINDINGS: Bindings = [
  { fire: 'Space', primary: 'KeyQ', secondary: 'KeyE', field: 'KeyR' },
  { fire: 'Enter', primary: 'KeyO', secondary: 'KeyP', field: 'KeyI' },
];
export const KEY_OPTIONS = ['Space', 'Enter', ...Array.from('ABCDEFGHIJKLMNOPQRSTUVWXYZ', c => `Key${c}`), ...Array.from('0123456789', c => `Digit${c}`), 'ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'ShiftLeft', 'ShiftRight'];
export function keyLabel(code: string): string {
  return ({ Space: '空格', Enter: 'Enter', ArrowUp: '↑', ArrowDown: '↓', ArrowLeft: '←', ArrowRight: '→', ShiftLeft: '左 Shift', ShiftRight: '右 Shift' } as Record<string, string>)[code] ?? code.replace(/^(Key|Digit)/, '');
}
